module.exports = __webpack_public_path__ + "static/img/1.1df603e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/1.png
// module id = rhWW
// module chunks = 0